const buildApiAction = (actionPrefix) => ({
    start: `${actionPrefix}_START`,
    success: `${actionPrefix}_SUCCESS`,
    failure: `${actionPrefix}_FAIL`,
});

export default buildApiAction;
